import { render, staticRenderFns } from "./UnsplashLayout.vue?vue&type=template&id=66728527&scoped=true&"
import script from "./UnsplashLayout.vue?vue&type=script&lang=js&"
export * from "./UnsplashLayout.vue?vue&type=script&lang=js&"
import style0 from "./UnsplashLayout.vue?vue&type=style&index=0&id=66728527&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66728527",
  null
  
)

export default component.exports